import { createIdSlice } from '../utils/action/createElementSlice';
const DefaultState = { isOpen: true, value: undefined };
export const AboutInfoState = createIdSlice({
    elementName: 'aboutInfo',
    initialState: {},
    reducers: {
        setValue(state = DefaultState, action) {
            return Object.assign(Object.assign({}, state), { value: action.payload.data });
        },
        toggleOpen(state = DefaultState) {
            return Object.assign(Object.assign({}, state), { isOpen: !state.isOpen });
        },
    },
});
